import { useEffect, useState } from "react";
import { generateRedirectUrl } from "../../api/idServer";
import Loader from "../../shared/Loader";
import LoginPage from "./loginPage";

export const RedirectLogin = () => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (process.env.REACT_APP_ENV !== "local") {
      setIsLoading(true);
    }
  }, []);

  return <>{isLoading ? <Loader /> : <LoginPage />}</>;
};
